import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { id: "vueMain" }
const _hoisted_2 = {
  key: 0,
  class: "ng-extend"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode($setup["Tutorial"]),
          _createVNode($setup["ExtensionBar"])
        ]))
      : _createCommentVNode("v-if", true),
    _cache[0] || (_cache[0] = _createElementVNode("div", { id: "content" }, [
      _createElementVNode("div", { id: "neuroglancer-container" })
    ], -1 /* HOISTED */))
  ]))
}